import {
  useMutation,
  useQueryClient,
} from "@tanstack/react-query";
import {
  createFileRoute,
  useNavigate,
} from "@tanstack/react-router";
import { toast } from "sonner";

import { ConnectionForm } from "@/azure-devops/components/connection-form";
import { useTRPC } from "@/infrastructure/trpc/react";
import { AppLayout } from "@/shared/layout";

export const Route = createFileRoute(
  "/app/organization/$id/azdo/add"
)({
  component: RouteComponent,
});

function RouteComponent() {
  const { id: organizationId } = Route.useParams();
  const navigate = useNavigate();
  const trpc = useTRPC();
  const queryClient = useQueryClient();

  const createConnection = useMutation(
    trpc.azureDevOps.create.mutationOptions({
      onSuccess: async () => {
        toast.success("Azure DevOps connection created");
        await queryClient.invalidateQueries(
          trpc.azureDevOps.list.queryOptions({
            organizationId,
          })
        );
        void navigate({
          to: "/app/organization/$id/settings/azure-devops",
          params: { id: organizationId },
        });
      },
      onError: (error) => {
        toast.error(
          error.message ?? "Failed to create connection"
        );
      },
    })
  );

  return (
    <AppLayout
      title="Add Azure DevOps Connection"
      headerActions={null}
    >
      <div className="mx-auto max-w-2xl">
        <ConnectionForm
          organizationId={organizationId}
          mode="add"
          onSubmit={async (values) => {
            await createConnection.mutateAsync({
              organizationId,
              ...values,
            });
          }}
          isSubmitting={createConnection.isPending}
          cardDescription="Connect to your Azure DevOps organization to monitor pipeline deployments"
          submitButtonText="Add Connection"
          submittingButtonText="Adding..."
        />
      </div>
    </AppLayout>
  );
}
